/* eslint camelcase: 0 */
import { Talk, TalkRequest } from '@/infrastructure/network/Monitaro/schema/models'
import { ITalkProps, EmptyTalkPropsFactory } from '@/entities/Talk'

export const toTalkProps = (props: Talk | null | undefined): ITalkProps => {
  if (!props) {
    return EmptyTalkPropsFactory()
  }

  const { id, room_id, talker, talker_id, talker_type, reads_count, message, deleted, system, properties, files, created_at, updated_at } = props

  return EmptyTalkPropsFactory({
    id,
    roomId: room_id,
    talker,
    talkerId: talker_id,
    talkerType: talker_type || '',
    readsCount: reads_count || 0,
    deleted,
    system,
    message,
    properties,
    files,
    createdAt: created_at,
    updatedAt: updated_at
  })
}

export const toTalkRequest = (props: ITalkProps): TalkRequest => {
  const { message, data } = props
  return {
    message: message!,
    files: data!
  }
}
